import Modulo2 from "../pages/modulo2/Modulo2";
import Modulo2Conclusion from "../pages/modulo2/Modulo2Conclusion";
import Modulo2U1A1 from "../pages/modulo2/unidad1/Actividad1";
import Modulo2U1A2 from "../pages/modulo2/unidad1/Actividad2";
import Modulo2U1A3 from "../pages/modulo2/unidad1/Actividad3";
import Modulo2U1A4 from "../pages/modulo2/unidad1/Actividad4";
import Modulo2U1A5 from "../pages/modulo2/unidad1/Actividad5";
import Modulo2U1A6 from "../pages/modulo2/unidad1/Actividad6";
import Modulo2U1A7 from "../pages/modulo2/unidad1/Actividad7";
import Modulo2U1A8 from "../pages/modulo2/unidad1/Actividad8";


export const modulo2 =
    {
      title: "Mi barrio y yo",
      grade: { name: "Nivel 1", url: "/nivel-1" },
      year: 'Primer grado',
      module: "Módulo 2",
      component: <Modulo2 />,
      conclusion: <Modulo2Conclusion />,
      tags: [
        { name: "barrio", url: "barrio" },
        { name: "distrito", url: "distrito" },
        { name: "localidad", url: "localidad" },
        { name: "comunidad", url: "comunidad" },
      ],
      skills: [
        { name: "Construye su identidad", url: "/construye-su-identidad" },
        {
          name: "Convive y participa democráticamente",
          url: "/convive-y-participa-democraticamente ",
        },
      ],
      url: "mi-barrio-y-yo",
      color: "green",
      content: [
        {
          name: "Unidad 1",
          path: "unidad-1",
          activities: [
            {
              name: "Actividad 1",
              path: "actividad-1",
              component: <Modulo2U1A1 />,
            },
            {
              name: "Actividad 2",
              path: "actividad-2",
              component: <Modulo2U1A2 />,
            },
            {
              name: "Actividad 3",
              path: "actividad-3",
              component: <Modulo2U1A3 />,
            },
            {
              name: "Actividad 4",
              path: "actividad-4",
              component: <Modulo2U1A4 />,
            },
            {
              name: "Actividad 5",
              path: "actividad-5",
              component: <Modulo2U1A5 />,
            },
            {
              name: "Actividad 6",
              path: "actividad-6",
              component: <Modulo2U1A6 />,
            },
            {
              name: "Actividad 7",
              path: "actividad-7",
              component: <Modulo2U1A7 />,
            },
            {
              name: "Actividad 8",
              path: "actividad-8",
              component: <Modulo2U1A8 />,
            },
          ]
        },
       
    ]
    };